import React from 'react';
import { SvgButton } from './styles';
import { Colors } from '~/config/Colors';

const ActionButtonIcon = ({
  icon,
  color = Colors.Color7,
  isDisabled,
  onClick,
  toltipText,
  ...rest
}) => (
  <SvgButton onClick={onClick} title={toltipText} color={color} isDisabled={isDisabled} {...rest}>
    <i className="material-icons">{icon}</i>
  </SvgButton>
);

export default ActionButtonIcon;
